// Solo i funnel commerciali Flusia, mai i calendari dei tenant SaaS.
export const FLUSIA_DEMO_EVENT_ID = '1606ae61-9227-45b1-a05c-09528e94da6d';

export function isFlusiaDemoEvent(eventId: unknown): boolean {
  return eventId === FLUSIA_DEMO_EVENT_ID;
}

export function isInternalMarketingTest(email: unknown): boolean {
  return typeof email === 'string' && /^luca\+qa-[a-z0-9._+-]+@obly\.it$/i.test(email.trim());
}

// ID persistito dal backend, senza email, telefono o token di autenticazione.
const dispatched = new Set<string>();
export function dispatchConversionOnce(eventId: string, dispatch: () => void): void {
  if (dispatched.has(eventId)) return;
  const key = `flusia:conversion:${eventId}`;
  try { if (sessionStorage.getItem(key) === 'sent') return; } catch { /* storage bloccato */ }
  dispatch();
  dispatched.add(eventId);
  try { sessionStorage.setItem(key, 'sent'); } catch { /* resta il guard in memoria */ }
}
